/* eslint-disable react/display-name */
import { Box, Text } from '@chakra-ui/core';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellProps, Column } from 'react-table';
import { ContractedHoursViewModel } from '../utils/RequisitionDetailsViewModel';
import { EmptyPlaceholder, GenericDataTable } from './components/TableComponents';
import colors from '../../../../../styles/colors';

interface ContractedHoursProps {
  contractedHours: ContractedHoursViewModel;
}

export const ContractedHours = memo(({ contractedHours }: ContractedHoursProps) => {
  const { t } = useTranslation('requisition');
  const { hasAny } = contractedHours;

  const columns = useMemo<Column<ContractedHoursViewModel>[]>(() => {
    return [
      {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        Header: t('minimum') as string,
        accessor: 'minLabel',
        isNumeric: true,
        disableSortBy: true,
        Cell: ({ value }: CellProps<ContractedHoursViewModel, string>) => (value ? <>{value}</> : <EmptyPlaceholder />),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        Header: t('maximum') as string,
        accessor: 'maxLabel',
        isNumeric: true,
        disableSortBy: true,
        Cell: ({ value }: CellProps<ContractedHoursViewModel, string>) => (value ? <>{value}</> : <EmptyPlaceholder />),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        Header: t('guaranteedHours') as string,
        accessor: 'guaranteedLabel',
        isNumeric: true,
        disableSortBy: true,
        Cell: ({ value }: CellProps<ContractedHoursViewModel, string>) => (value ? <>{value}</> : <EmptyPlaceholder />),
      },
    ];
  }, [t]);

  const data = useMemo(() => [contractedHours], [contractedHours]);

  if (!hasAny) return null;

  return (
    <Box mt="20px" data-testid="contracted-hours-section">
      <Text fontSize="14px" fontWeight={700} mb="8px" data-testid="contracted-hours-title">
        {t('contractedHours')}
      </Text>
      <Box border="1px solid" borderColor={colors.gray[250]} data-testid="contracted-hours-table">
        <GenericDataTable columns={columns} data={data} />
      </Box>
    </Box>
  );
});

ContractedHours.displayName = 'ContractedHours';
